<template>
    <a-layout class="help">
        <a-layout-header>
            <page-nav></page-nav>
        </a-layout-header>
        <a-layout-content class="help-body">
            <section class="fixed-help">
                <div class="fixed-help__inner">
                    <h1>{{ $t('help_pages.center_title') }}</h1>
                    <p class="fixed-help__intro">{{ $t('help_pages.center_intro') }}</p>
                    <div class="fixed-help__entries">
                        <button type="button" class="fixed-help__entry" @click="$router.push('/help/faq')">
                            <span>
                                <strong>{{ $t('help_pages.faq_title') }}</strong>
                                <small>{{ $t('help_pages.faq_description') }}</small>
                            </span>
                            <icon-right size="20" />
                        </button>
                        <button type="button" class="fixed-help__entry" @click="$router.push('/help/announcements')">
                            <span>
                                <strong>{{ $t('help_pages.announcements_title') }}</strong>
                                <small>{{ $t('help_pages.announcements_description') }}</small>
                            </span>
                            <icon-right size="20" />
                        </button>
                    </div>
                    <section class="fixed-help__service">
                        <img :src="require(`@/assets/images/help/index_help_${userTheme}.png`)" alt="">
                        <div class="fixed-help__service-info">
                            <p>{{ $t('help.still_cant_solve') }}</p>
                            <p>{{ $t('help.multilingual_service') }}</p>
                            <a-button class="fixed-help__service-button" @click="openCustomerService">{{ $t('help.start_conversation') }}</a-button>
                        </div>
                    </section>
                </div>
            </section>
        </a-layout-content>
        <a-layout-footer>
            <Footer></Footer>
        </a-layout-footer>
    </a-layout>
</template>

<script>
import PageNav from "@/components/PageNav/PageNav.vue";
import Footer from "@/components/Footer/footer.vue";
import {mapGetters} from "vuex";

export default {
    components: {
        PageNav,
        Footer
    },
    computed: {
        ...mapGetters(['userTheme'])
    },
    methods: {
        openCustomerService() {
            try {
                const kefuUrl = this.$store.state.config?.kefu_url;

                if (kefuUrl && kefuUrl.trim() !== '') {
                    window.open(kefuUrl, '_blank');
                    return;
                }

                this.$message.warning(this.$t('help.customer_service_not_configured'));
            } catch (error) {
                console.error('Failed to open customer service:', error);
                this.$message.error(this.$t('help.open_customer_service_failed'));
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.fixed-help {
    min-height: 0;
    padding: 64px 24px 72px;
    background: var(--background-primary);
    box-sizing: border-box;
}

.fixed-help__inner {
    width: min(100%, 920px);
    margin: 0 auto;
}

.fixed-help h1 {
    margin: 0;
    color: var(--content-primary);
    font-size: 40px;
    line-height: 1.3;
    font-weight: 700;
}

.fixed-help__intro {
    max-width: 720px;
    margin: 14px 0 30px;
    color: var(--content-secondary);
    font-size: 16px;
    line-height: 1.7;
}

.fixed-help__entries {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px;
}

.fixed-help__service {
    width: 100%;
    min-height: 196px;
    margin: 28px 0 0;
    padding: 24px 42px;
    display: grid;
    grid-template-columns: minmax(140px, 168px) minmax(0, 510px);
    align-items: center;
    justify-content: center;
    column-gap: 36px;
    border: 1px solid var(--border-strength-100);
    border-radius: 8px;
    background: var(--background-secondary);
    box-sizing: border-box;
}

.fixed-help__service img {
    width: 168px;
    max-width: 100%;
    height: auto;
}

.fixed-help__service-info {
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.fixed-help__service-info p {
    margin: 0;
    color: var(--content-primary);
    font-size: 23px;
    line-height: 1.4;
    font-weight: 600;
    overflow-wrap: anywhere;
}

.fixed-help__service-info p + p {
    margin-top: 8px;
    color: var(--content-secondary);
    font-size: 15px;
    line-height: 1.6;
    font-weight: 400;
    overflow-wrap: anywhere;
}

.fixed-help__service-button {
    height: 40px;
    margin-top: 16px;
    padding: 0 20px;
    border: 0;
    border-radius: 4px;
    background: var(--color-primary);
    color: var(--color-always-white);
}

.fixed-help__entry {
    min-height: 132px;
    padding: 24px 22px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    border: 1px solid var(--border-strength-100);
    border-radius: 8px;
    background: var(--background-secondary);
    color: var(--content-primary);
    text-align: left;
    cursor: pointer;
    transition: border-color .15s ease, transform .15s ease;
}

.fixed-help__entry:hover {
    border-color: var(--color-primary);
    transform: translateY(-2px);
}

.fixed-help__entry span {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.fixed-help__entry strong {
    font-size: 20px;
    line-height: 1.4;
}

.fixed-help__entry small {
    color: var(--content-secondary);
    font-size: 14px;
    line-height: 1.6;
}

@media (max-width: 768px) {
    .fixed-help {
        padding: 48px 20px 64px;
    }

    .fixed-help h1 {
        font-size: 30px;
    }

    .fixed-help__entries {
        grid-template-columns: 1fr;
    }

    .fixed-help__service {
        min-height: 0;
        padding: 24px;
        grid-template-columns: minmax(124px, 150px) minmax(0, 1fr);
        align-items: flex-start;
        column-gap: 24px;
    }

    .fixed-help__service img {
        width: 150px;
    }

    .fixed-help__service-info p {
        font-size: 20px;
    }
}

@media (max-width: 560px) {
    .fixed-help__service {
        grid-template-columns: 1fr;
        row-gap: 18px;
    }

    .fixed-help__service img {
        width: 142px;
    }
}
</style>
